export default __webpack_public_path__ + "static/media/know.df7bed46.png";